import { MarketConfiguration } from "@/config/markets/const";
import { FirebaseError } from "firebase/app";
import type { Auth, Persistence } from "firebase/auth";
import clearAuthCookie from "./clearAuthCookie";
import { clearSessionEstablishment } from "./establishSession";

export type EmailSignInProps = {
  auth: Auth;
  type?: Persistence;
  email: string;
  password: string;
  market: MarketConfiguration;
};

export default async function signInWithEmail({
  auth,
  type,
  email,
  password,
}: EmailSignInProps) {
  const {
    browserLocalPersistence,
    setPersistence,
    signInWithEmailAndPassword,
  } = await import("firebase/auth");

  await setPersistence(auth, type ?? browserLocalPersistence);

  try {
    const response = await signInWithEmailAndPassword(auth, email, password);

    if (!response.user) {
      throw new Error("No user in response");
    }

    return response.user;
  } catch (error) {
    clearSessionEstablishment();
    void clearAuthCookie();
    if (error instanceof FirebaseError || error instanceof Error) {
      throw error;
    }
    throw new Error("An error occurred while signing in with email");
  }
}
